import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { bindPromiseCreators } from '../../utils/routines';
import { withDeleteUserSaga } from './saga'
import { createDeleteUserPromise } from './routines';

import Confirm from '../../components/Confirm/ConfirmController'
import Button from '../../components/Button'
import CircularProgress from '../../components/CircularProgress';
import Modal from '../../components/Modal/Modal';
import H1 from '../../components/H1';
import { PaneActions } from '../../components/Pane';

class ProfileDeleteButton extends Component {
  state = {
    error: null,
    requesting: false
  }

  handleDelete = async () => {
    try {
      this.setState({ requesting: true })
      await this.props.delete(this.props.userProfile.id)
    } catch (error) {
      this.setState({ requesting: false, error })
    }
  }

  render() {
    return (
      <Confirm onConfirm={this.handleDelete}>
        {({ opened, showConfirm, hideConfirm, handleConfirm }) => (
          <Fragment>
            <Button size='s' type='button' onClick={showConfirm}>
              Eliminar perfil
            </Button>
            {opened && (
              <Modal handleClose={hideConfirm}>
                <H1 size='small'>Eliminar mi perfil</H1>
                <p>Recuerda que al eliminar tu perfil perderemos todos los datos sobre ti y tus solicitudes, por lo que no podremos atender cualquier solicitud que aún no hayamos comenzado a estudiar. ¿Estás seguro que quieres eliminar tú perfil?</p>
                <PaneActions>
                  <Button onClick={handleConfirm} size='s' primary>
                    Si, eliminar
                    {this.state.requesting && <CircularProgress size={18} />}
                  </Button>
                  <Button onClick={hideConfirm} size='s'>
                    No, cancelar
                  </Button>
                </PaneActions>
              </Modal>
            )}
          </Fragment>
        )}
      </Confirm>
    )
  }
}

const mapDispatchToProps = bindPromiseCreators({
  delete: createDeleteUserPromise
})
const connector = connect(null, mapDispatchToProps)

const enhancer = compose(
  withDeleteUserSaga,
  connector
)

export default enhancer(ProfileDeleteButton)
